export const KERNEL_EVENT_TYPES = [
    "transport.state-changed",
    "stage.catalog-invalidated",
    "stage.registry-changed",
    "query.invalidated",
    "outbox.state-changed",
    "domain.entity-changed",
    "sync.delta-applied",
    "client-storage.state-changed",
];
export function isKernelEventType(value) {
    return KERNEL_EVENT_TYPES.includes(value);
}
export function isQueryName(value) {
    return /^.+\.v\d+$/u.test(value);
}
//# sourceMappingURL=index.js.map